var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.636.156l1.526 1.526a.536.536 0 01.003.759l-.849.848-2.284-2.284.848-.85a.536.536 0 01.756 0zM.012 7.654l.492-2.121 4.083-4.088 2.287 2.282-4.098 4.082-2.135.492a.554.554 0 01-.111 0 .533.533 0 01-.518-.647z",
    fill: "#1D426D"
  })));
}

export default SvgPencil;